const changeViewDropdown = {
  company: {
    body: 'Are you sure you want to change the company?',
  },
  site: {
    body: 'Are you sure you want to change the site?',
  },
};

export default changeViewDropdown;
